export default __webpack_public_path__ + "static/media/security-details-download-termsheet.960e7442.svg";